import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";
import {makeInitialInfoItems, makeRequesterItems} from "../helpers/initial-info-items.js";

export default function InitialInfo({ data, title, printOptions }) {
    const schedule = data?.schedule ?? {};
    const initialItems = makeInitialInfoItems(data);
    const requesterItems = makeRequesterItems(data);

    return (
        <>
            <InfoGrid title={title} items={initialItems} columns={3} />

            <div className={printOptions?.showRequesters ? "" : "print:hidden"}>
                <InfoGrid items={requesterItems} columns={2} />
            </div>

            <div className="flex flex-col gap-6 px-5 mt-8">
                <ObservationBox title="Descrição">
                    {schedule?.description ?? ""}
                </ObservationBox>

                {!!schedule?.inactive && (
                    <ObservationBox title="Motivo da inativação">
                        {schedule?.inactive_observation ?? ""}
                    </ObservationBox>
                )}
            </div>
        </>
    )
}
